<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowUpArrowDown } from '@fortawesome/pro-solid-svg-icons'
import { PendoFeature } from '~/models/Pendo'
import Button from '~/components/ui/Button.vue'

export type SortMode = 'timestamp-asc' | 'timestamp-desc'

const { modelValue } = defineProps<{
  modelValue: SortMode
}>()

const emit = defineEmits<{
  'update:modelValue': [value: SortMode]
}>()

const { t } = useI18n()

const sortButtonText = computed(() => {
  return modelValue === 'timestamp-desc'
    ? t('reports.sort.newestFirst')
    : t('reports.sort.oldestFirst')
})

function toggleSortMode() {
  const newValue: SortMode = modelValue === 'timestamp-desc' ? 'timestamp-asc' : 'timestamp-desc'
  emit('update:modelValue', newValue)
}
</script>

<template>
  <Button
    size="sm"
    variant="ghost"
    shade="dark"
    color="green"
    :data-pendo="PendoFeature.ActivityReports.ActivitySort"
    @click="toggleSortMode"
  >
    {{ sortButtonText }}
    <FontAwesomeIcon
      :icon="faArrowUpArrowDown"
      aria-hidden="true"
    />
  </Button>
</template>
